@if (ds().publicSettings) {
  <mat-horizontal-stepper linear #stepper class="pay-stepper">
    <ng-template matStepperIcon="number" let-index="index">
      <ng-container [ngTemplateOutlet]="stepperIconContent" [ngTemplateOutletContext]="{ index: index }"></ng-container>
    </ng-template>
    <ng-template matStepperIcon="edit" let-index="index">
      <ng-container [ngTemplateOutlet]="stepperIconContent" [ngTemplateOutletContext]="{ index: index }"></ng-container>
    </ng-template>
    <ng-template matStepperIcon="done" let-index="index">
      <ng-container [ngTemplateOutlet]="stepperIconContent" [ngTemplateOutletContext]="{ index: index }"></ng-container>
    </ng-template>

    <ng-template #stepperIconContent let-index="index">
      @switch (index) {
        @case (0) {
          <mat-icon>shopping_cart</mat-icon>
        }
        @case (1) {
          <mat-icon>{{ paymentMethods().length > 1 ? 'add_card' : 'person_edit' }}</mat-icon>
        }
        @case (2) {
          <mat-icon>{{ paymentMethods().length > 1 ? 'person_edit' : 'check_small' }}</mat-icon>
        }
        @case (3) {
          <mat-icon>check_small</mat-icon>
        }
      }
    </ng-template>

    <mat-step [stepControl]="planForm">
      <ng-template matStepLabel>Betaalplan kiezen</ng-template>
      <div class="cards">
        @for (plan of plans(); track plan) {
          <div class="card-wrapper">
            <div
              role="button"
              tabindex="0"
              (click)="this.planForm.controls.planId.setValue(plan.id); stepper.next()"
              (keydown.enter)="this.planForm.controls.planId.setValue(plan.id); stepper.next()"
              (keydown.space)="$event.preventDefault(); this.planForm.controls.planId.setValue(plan.id); stepper.next()"
              class="card plan"
              [attr.aria-label]="'Selecteer betaalplan: ' + plan.name"
              [attr.aria-pressed]="plan.id === planForm.value.planId"
              [class.active]="plan.id === planForm.value.planId"
            >
              <div class="card-content">
                <h3 class="card-title">
                  {{ plan.name }}
                </h3>
                <p class="currency">
                  {{
                    plan.startAmount
                      .toLocaleString('nl-NL', {
                        style: 'currency',
                        currency: 'EUR',
                      })
                      .replace(',00', ',-')
                  }}
                </p>
                <p class="price">Start bedrag</p>
                <p class="info">
                  {{ plan.description }}
                </p>
              </div>
            </div>
          </div>
        }
      </div>
    </mat-step>
    <!-- Payment method step -->
    @if (paymentMethods().length > 1) {
      <mat-step [stepControl]="paymentForm">
        <ng-template matStepLabel>Betaalmethode</ng-template>
        <div class="cards">
          @if (ds().publicSettings?.mollieEnabled) {
            <div
              role="button"
              tabindex="0"
              class="card-wrapper"
              aria-label="Selecteer betaalmethode: iDEAL of Wero"
              [attr.aria-pressed]="paymentForm.value.selectedPaymentOption === paymentMethod.MOLLIE"
              (click)="this.paymentForm.controls.selectedPaymentOption.setValue(paymentMethod.MOLLIE); stepper.next()"
              (keydown.enter)="
                this.paymentForm.controls.selectedPaymentOption.setValue(paymentMethod.MOLLIE); stepper.next()
              "
              (keydown.space)="
                $event.preventDefault();
                this.paymentForm.controls.selectedPaymentOption.setValue(paymentMethod.MOLLIE);
                stepper.next()
              "
            >
              <div
                class="card payment-option"
                [class.active]="paymentForm.value.selectedPaymentOption === paymentMethod.MOLLIE"
              >
                <h3 class="card-title">iDEAL / Wero</h3>
                <div class="currency">
                  <img mat-card-image src="../../assets/images/iDEAL-Wero_logo.png" alt="iDEAL en Wero logo" />
                </div>
                <div class="info-payment">Online betaling via iDEAL / Wero</div>
              </div>
            </div>
          }
          @if (ds().publicSettings?.sepaEnabled) {
            <div
              role="button"
              tabindex="0"
              class="card-wrapper"
              aria-label="Selecteer betaalmethode: SEPA"
              [attr.aria-pressed]="paymentForm.value.selectedPaymentOption === paymentMethod.SEPA"
              (click)="this.paymentForm.controls.selectedPaymentOption.setValue(paymentMethod.SEPA); stepper.next()"
              (keydown.enter)="
                this.paymentForm.controls.selectedPaymentOption.setValue(paymentMethod.SEPA); stepper.next()
              "
              (keydown.space)="
                $event.preventDefault();
                this.paymentForm.controls.selectedPaymentOption.setValue(paymentMethod.SEPA);
                stepper.next()
              "
            >
              <div
                class="card payment-option"
                [class.active]="paymentForm.value.selectedPaymentOption === paymentMethod.SEPA"
              >
                <h3 class="card-title">SEPA</h3>
                <div class="currency">
                  <img mat-card-image src="../../assets/images/SEPA_logo.png" alt="SEPA logo" />
                </div>
                <div class="info-payment">Betaling met een SEPA-machtigingsformulier</div>
              </div>
            </div>
          }
        </div>
      </mat-step>
    }
    <!-- Personal info step -->
    <mat-step [stepControl]="personalForm">
      <ng-template matStepLabel>Persoonsgegevens</ng-template>
      <form class="personal-form" [formGroup]="personalForm">
        <div class="form-field-group">
          <!-- FieldType name-->
          <mat-form-field>
            <mat-label>Voor- & achternaam</mat-label>
            <input autocomplete="name" matInput formControlName="name" placeholder="Voornaam Achternaam" />
            @if (personalForm.controls.name.hasError('required')) {
              <mat-error>Vul dit veld in.</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-field-group">
          <!-- FieldType postal-code -->
          <mat-form-field>
            <mat-label>Postcode</mat-label>
            <input
              autocomplete="postal-code"
              matInput
              data-lpignore="true"
              formControlName="postal"
              placeholder="Postcode"
              #postalCode
            />
            @if (personalForm.controls.postal.hasError('required')) {
              <mat-error>Vul dit veld in.</mat-error>
            }
            @if (personalForm.controls.postal.hasError('postalValidator')) {
              <mat-error>Postcode is ongeldig.</mat-error>
            }
          </mat-form-field>
          <!-- FieldType houseNumber -->
          <mat-form-field>
            <mat-label>Huisnummer</mat-label>
            <input
              autocomplete="address-line2"
              matInput
              formControlName="houseNumber"
              placeholder="Huisnummer"
              (input)="formatNumericInput($event, personalForm, 'houseNumber', true)"
            />
            @if (personalForm.controls.houseNumber.hasError('required')) {
              <mat-error>Huisnummer is verplicht.</mat-error>
            }
          </mat-form-field>
          <!-- FieldType houseNumberAddition -->
          <mat-form-field>
            <mat-label>Toevoeging</mat-label>
            <input matInput formControlName="houseNumberAddition" autocomplete="off" placeholder="Toevoeging" />
            <mat-hint>Optioneel</mat-hint>
          </mat-form-field>
        </div>
        <div class="form-field-group">
          <!-- FieldType streetName -->
          <mat-form-field>
            <mat-label>Straatnaam</mat-label>
            <input autocomplete="address-line1" matInput formControlName="streetName" placeholder="Straatnaam" />
            @if (personalForm.controls.streetName.hasError('required')) {
              <mat-error>Vul dit veld in.</mat-error>
            }
          </mat-form-field>
          <!-- FieldType City-->
          <mat-form-field>
            <mat-label>Plaatsnaam</mat-label>
            <input autocomplete="address-level2" matInput formControlName="city" placeholder="Plaatsnaam" />
            @if (personalForm.controls.city.hasError('required')) {
              <mat-error>Vul dit veld in.</mat-error>
            }
          </mat-form-field>
        </div>
        <!-- FieldType iban -->
        @if (personalForm.controls.iban.enabled) {
          <mat-form-field>
            <mat-label>IBAN</mat-label>
            <input matInput formControlName="iban" data-lpignore="true" autocomplete="off" placeholder="IBAN" />
            @if (personalForm.controls.iban.hasError('required')) {
              <mat-error>Vul dit veld in.</mat-error>
            }
            @if (personalForm.controls.iban.hasError('ibanValidator')) {
              <mat-error>De IBAN moet bijvoorbeeld NL91ABNA0417164300 zijn.</mat-error>
            }
          </mat-form-field>
        }
      </form>
    </mat-step>
    <!-- Payment step -->
    <mat-step [stepControl]="payForm">
      <ng-template matStepLabel>Bevestiging</ng-template>
      @if (paymentForm.controls['selectedPaymentOption'].value === paymentMethod.MOLLIE) {
        <div>
          <div class="cards">
            <div class="card-wrapper">
              @if (selectedPlan()) {
                <div class="card plan pay-step">
                  <div class="card-content">
                    <h3 class="card-title">
                      {{ selectedPlan()!.name }}
                    </h3>
                    <div class="currency">
                      {{
                        selectedPlan()!
                          .startAmount.toLocaleString('nl-NL', {
                            style: 'currency',
                            currency: 'EUR',
                          })
                          .replace(',00', ',-')
                      }}
                    </div>
                    <div class="info">Start bedrag</div>
                    <div class="info">
                      {{ selectedPlan()!.description }}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <form [formGroup]="payForm" class="pay-form">
            <a target="_blank" href="{{ sanitizeUrl(ds().publicSettings.privacyLink ?? '#') }}">
              Lees privacyvoorwaarden
            </a>
            <mat-checkbox formControlName="termsAccepted"> Accepteer privacyvoorwaarden </mat-checkbox>
          </form>
        </div>
      } @else if (paymentForm.controls['selectedPaymentOption'].value === paymentMethod.SEPA) {
        <div class="confirm-request-container">
          <h1 class="confirm-request-title">Bevestig bij deze jouw aanvraag</h1>
          <p class="confirm-request-description">
            Jouw aanvraag wordt naar {{ ds().selectedOrganisation.name }} gestuurd. Zij nemen zo snel mogelijk contact
            met je op over de status van jouw aanvraag.
          </p>
        </div>
      }
    </mat-step>
  </mat-horizontal-stepper>

  <div class="pay-stepper-navigation">
    @if (stepper.selectedIndex > 0) {
      <button mat-button (click)="stepper.previous()">Vorige</button>
    } @else {
      <button routerLink="/profile" mat-button>Annuleren</button>
    }

    @if (stepper.selectedIndex === (paymentMethods().length > 1 ? 2 : 1)) {
      <button mat-flat-button (click)="stepper.next()" [disabled]="personalForm.invalid">Volgende</button>
    } @else if (stepper.selectedIndex === (paymentMethods().length > 1 ? 3 : 2)) {
      <button
        mat-flat-button
        [disabled]="!payForm.valid && paymentForm.controls['selectedPaymentOption'].value === paymentMethod.MOLLIE"
        (click)="pay()"
        [class.spinner]="awaitingResponse()"
      >
        {{ this.paymentForm.value.selectedPaymentOption === paymentMethod.MOLLIE ? 'Betalen' : 'Bevestigen' }}
      </button>
    }
  </div>
}
